var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudioIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_65",
    "data-name": "Union 65",
    d: "M13,20a2.055,2.055,0,0,1-2-2.105V13.684a2.055,2.055,0,0,1,2-2.105h4a2.055,2.055,0,0,1,2,2.105v4.211A2.055,2.055,0,0,1,17,20Zm-.2-6.316v4.211a.206.206,0,0,0,.2.21h4a.206.206,0,0,0,.2-.21V13.684a.206.206,0,0,0-.2-.21H13A.206.206,0,0,0,12.8,13.684Zm-7.623.2a9.766,9.766,0,0,1-1-4.419l1.5.026a8.209,8.209,0,0,0,.769,3.557c.617,1.038,2.531,1.69,3.217,1.854l-.328,1.54C9.022,16.363,6.234,15.661,5.177,13.88ZM17,8.421a2.055,2.055,0,0,1-2-2.105V2.105A2.055,2.055,0,0,1,17,0h4a2.055,2.055,0,0,1,2,2.105V6.316a2.055,2.055,0,0,1-2,2.105Zm-.2-6.316V6.316a.205.205,0,0,0,.2.21h4a.206.206,0,0,0,.2-.21V2.105a.206.206,0,0,0-.2-.21H17A.205.205,0,0,0,16.8,2.105ZM2,8.421A2.055,2.055,0,0,1,0,6.316V2.105A2.055,2.055,0,0,1,2,0H6A2.055,2.055,0,0,1,8,2.105V6.316A2.055,2.055,0,0,1,6,8.421ZM1.8,2.105V6.316a.206.206,0,0,0,.2.21H6a.206.206,0,0,0,.2-.21V2.105a.206.206,0,0,0-.2-.21H2A.206.206,0,0,0,1.8,2.105ZM9.5,5V3.421h4V5Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioIcon);
export default __webpack_public_path__ + "static/media/StudioIcon.c80dba2667f1ceccb5ec07a2eddba855.svg";
export { ForwardRef as ReactComponent };